<template>
  <div class="market-descriptions">
    <h2 class="body-title">
      {{ t('Description') }}
    </h2>
    <div class="market-descriptions__wrapper">
      <article
        v-for="(desc, index) in descriptions"
        :key="`${desc.name}--${index}`"
        class="desc-item"
      >
        <div class="f fs gap8 desc-item__title">
          <svg
            height="24"
            width="24"
          >
            <use :xlink:href="`/icons/sprite.svg#${desc.icon_name}`" />
          </svg>
          <h3>
            {{ desc.name }}
          </h3>
        </div>
        <div
          class="desc-item__subtitle"
          v-html="desc.value"
        />
      </article>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { MarketFullInfoDescription } from '~/graphql/generated/schema-types';

defineProps<{
  descriptions: MarketFullInfoDescription[]
}>();
const { t } = useI18n();
</script>

<style lang="scss" scoped>
.market-descriptions {
  &__wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    gap: 16px;
  }

  .desc-item {
    padding: 20px 24px;
    border-radius: 12px;
    background: var(--surfaces-low-container);

    &__title {
      margin-bottom: 16px;

      h3 {
        overflow: hidden;
        color: var(--surfaces-on-surface);
        font-kerning: none;
        text-overflow: ellipsis;
        font-size: 18px;
        font-style: normal;
        font-weight: 800;
        line-height: 24px; /* 133.333% */
      }

      svg {
        color: var(--accent-on-surface);
      }
    }

    &__subtitle {
      color: var(--surfaces-on-surface-variable);
      font-kerning: none;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px; /* 200% */
      &:deep(a) {
        color: var(--accent-on-surface);
        text-decoration: underline;
      }
    }
  }

  @media screen and (max-width: 850px) {
    &__wrapper {
      grid-template-columns: 1fr;
    }
  }
}
</style>
